$ = require 'jquery'
_ = require 'underscore'
Analytics = require('common/debug/behavioral-analytics').default
Auth = require 'db/auth'
BaseDirectoryView = require 'views/directory/base-directory-view'
Controller = require 'controller'
directoryLegacyPowerUps = require './directory-legacy-power-ups'
DirectoryEnabledView = require 'views/directory/directory-enabled-view'
DirectoryListingView = require 'views/directory/directory-listing-view'
DirectoryHeaderView = require 'views/directory/directory-header-view'
DirectoryHomeView = require 'views/directory/directory-home-view'
DirectorySearchView = require 'views/directory/directory-search-view'
DirectorySpinnerView = require 'views/directory/directory-spinner-view'
DirectoryPageView = require 'views/directory/directory-page-view'
DirectoryPluginEnableView = require 'views/directory/directory-plugin-enable-view'
DirectorySidebarView = require 'views/directory/directory-sidebar-view'
elasticlunr = require 'elasticlunr'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
ModelLoader = require 'db/model-loader'
pluginsChangedSignal = require 'views/internal/plugins/plugins-changed-signal'
PluginIOCache = require 'views/internal/plugins/plugin-io-cache'
Promise = require 'bluebird'
trackUe = require 'debug/trackUe'
React = require 'react'
UserInput = require 'views/internal/user-input'
View = require 'view'
xtend = require 'xtend'

{ categories } = require 'data/directory'

getPageName = (section, category, idPlugin, search) ->
  page = 'home page'

  if search
    page = 'search'
  else if idPlugin
    page = 'list page'
  else if section in ['enabled', 'custom']
    page = section + ' page'
  else if section == 'category'
    page = "category #{ category } page"

  return "Power-Up directory #{ page }"

module.exports = class DirectoryView extends View
  className: 'directory-wrapper'

  initialize: ({ @boardView }) ->
    super

    # State
    @featuredPlugins = []
    @history = []
    @isLoading = true
    @plugins = []
    @search = null
    @isEnabling = false

    # Layout Subviews
    @headerView = @subview(DirectoryHeaderView, @model, directoryView: @)
    @sidebarView = @subview(DirectorySidebarView, @model, directoryView: @)

    # Routes
    @category = @options.category
    @section = @options.section
    @idPlugin = @options.idPlugin

    # Redirect invalid routes to home.
    if @section? && !_.contains(['enabled', 'category', 'custom'], @section)
      @navigate()

    if @category? && !_.contains(categories, @category)
      @navigate()

    @pluginSearchIndex = elasticlunr(->
      @addField('name')
      @addField('description')
      @setRef('id')
      @saveDocument(false)
      return
    )

    @preparePlugins()

    @makeDebouncedMethods 'onOrganizationChange'

    @listenTo @model.boardPluginList,
      'add remove reset': @onPluginChange
    @listenTo @model,
      'change:powerUps': @onPluginChange
      'change:idOrganization': @onOrganizationChangeDebounced

    @subscribe pluginsChangedSignal(@model), => @onPluginChange()

    UserInput.addHandler(@, {
      scope: 'power_ups_directory'
    })

    @trackSearch = _.debounce @trackSearch, 5000, true

  events:
    'shortcut': 'shortcut'
    'click .js-directory-responsive-overlay': 'toggleNavigationMenu'

  shortcut: (key) ->
    switch key
      when Keys.Escape
        if !@$('.js-directory-search').is(":focus")
          @boardView.closeDirectory()
          ["Esc - Close Power-Ups Directory", "Power-Ups Directory"]

  onOrganizationChange: ->
    @isLoading = true
    @sidebarView.render()
    @renderSubview()

    @model.loadPlugins()
      .then => @preparePlugins()

  onPluginChange: (e) ->
    @setBodyHeight()

  toggleNavigationMenu: ->
    directorySidebar = $('.js-directory-sidebar')
    responsiveOverlay = $('.js-directory-responsive-overlay')

    if directorySidebar.hasClass('active')
      directorySidebar.removeClass('active')
      responsiveOverlay.removeClass('active')
    else
      directorySidebar.addClass('active')
      responsiveOverlay.addClass('active')

  # ------- Data Methods -------
  # Get Power-Ups and prepare search index.
  preparePlugins: ->
    if @boardView.reloadDirectoryPlugins
      pluginPromise = @model.loadPlugins()
      @boardView.reloadDirectoryPlugins = false
    else
      pluginPromise = @model.getAvailablePlugins()

    pluginPromise
      .then (plugins) =>
        @plugins = plugins
        @pluginTerms = {}
        _.each plugins, (plugin) =>
          io = PluginIOCache.get(plugin)

          @pluginSearchIndex.addDoc({
            id: plugin.id
            name: io.getName(),
            description: io.getDescription()
          })

        @isLoading = false

        # Redirect to home if there are no custom plugins or plugin does not exist
        if (@section == 'custom' && !@getCustomPlugins().length) || (@idPlugin && !@getPlugin())
          return @navigate()

        # Redirect to home if plugin exists, but is hidden
        if @idPlugin
          plugin = @getPlugin()
          if plugin.get('moderatedState') in ['hidden', 'moderated']
            return @navigate()

        @sidebarView.render()
        @renderSubview()

  # Return common attributes to send in tracking events
  getCommonTrackingAttributes: ->
    boardId: @model.id
    organizationId: @model.get('idOrganization')

  # Get plugin by @idPlugin
  getPlugin: ->
    _.find @plugins, (p) => p.id == @idPlugin

  # Get plugins for the current category
  getPluginsForCategory: ->
    _.chain @plugins
      .filter (plugin) => @category in plugin.get('categories')
      .sortBy (plugin) -> PluginIOCache.get(plugin).getName().toLowerCase()
      .value()

  # Get custom plugins for board
  getCustomPlugins: ->
    _.chain @plugins
      .filter (plugin) -> !plugin.get('public')
      .sortBy (plugin) -> PluginIOCache.get(plugin).getName().toLowerCase()
      .value()

  # Search logic
  getPluginsForSearch: ->
    searchResultsById = _.indexBy(@pluginSearchIndex.search(@search, { expand: true }), 'ref')

    _.chain @plugins
      .filter((plugin) -> _.contains(Object.keys(searchResultsById), plugin.id))
    .sortBy (plugin) -> searchResultsById[plugin.id].score
    .reverse()
    .value()

  getEnabledPlugins: ->
    combinedPlugins = _.flatten([@model.idPluginsEnabled(), @model.get('powerUps')])
    _.chain combinedPlugins
      .map (idOrName) =>
        _.find @plugins, (plugin) =>
          plugin.id == idOrName || _.findWhere directoryLegacyPowerUps,
            id: plugin.id
            name: idOrName
      .compact()
      .sortBy (plugin) -> PluginIOCache.get(plugin).getName().toLowerCase()
      .value()

  # Filter out hidden and moderated plugins from existing list of plugins
  filterOutHiddenPlugins: (plugins) ->
    _.filter(plugins, (plugin) ->
      plugin.get('moderatedState') not in ['hidden', 'moderated']
    )

  updateSearch: (searchTerm) ->
    return if searchTerm == @search
    @search = searchTerm
    @renderSubview()

  trackSearch: ->
    trackUe(getPageName(@section, @category, @idPlugin), 'opens', @getCurrentPage())

  trackScreenEvent: (name, attributes) ->
    Analytics.sendScreenEvent
      name: name,
      attributes: _.extend(attributes, @getCommonTrackingAttributes())

  # ------- Navigation Methods -------
  getCurrentPage: ->
    getPageName(@section, @category, @idPlugin, @search)

  navigate: ({ section, category, idPlugin, isNavigatingBack, isEnabling } = {}) ->
    # Push to history if we're not traversing back or already on the same page
    if !isNavigatingBack && !_.isEqual({ @section, @category, @idPlugin, @isEnabling }, { section, category, idPlugin, isEnabling })
      @history.push { @section, @category, @idPlugin, @isEnabling }

    baseSlug = 'power-ups'

    if idPlugin
      baseSlug = 'power-up'
      trackUe(@getCurrentPage(), 'opens', getPageName(section, category, idPlugin), '', '', '', idPlugin)
    else
      trackUe(@getCurrentPage(), 'opens', getPageName(section, category))

    @section = section
    @category = category
    @idPlugin = idPlugin

    path = []
    path.push(@section) if @section?
    path.push(@category) if @category?
    path.push(@idPlugin) if @idPlugin?

    @isEnabling = !!isEnabling

    Controller.setBoardLocation(
      @model.id,
      baseSlug,
      path,
      { replace: false }
    )

    @search = null
    @sidebarView.clearSearch()

    @sidebarView.render()
    @headerView.render()
    @renderSubview()

  navigateBack: ->
    if _.isEmpty @history
      return @navigate({ isNavigatingBack: true })

    { section, category, idPlugin } = @history.pop()
    @navigate({ section, category, idPlugin, isNavigatingBack: true })

  # ------- Subviews and UI Methods -------
  # When the upsell banner pops up we need to reduce the space in the directory body.
  setBodyHeight: (manuallyDismissed) ->
    if manuallyDismissed || (@model.canEnableAdditionalPowerUps())
      @$('.js-directory-body').removeClass('has-upsell')
    else if !Auth.me().isAdDismissed('DirectoryBusinessClassBanner')
      @$('.js-directory-body').addClass('has-upsell')

  homeSubview: ->
    @subview(DirectoryHomeView, @model, {
      currentPage: @getCurrentPage()
      directoryView: @
    })

  enabledSubview: ->
    @subview(DirectoryEnabledView, @model, {
      plugins: @plugins
      currentPage: @getCurrentPage()
      directoryView: @
    })

  pluginListingSubview: ->
    @subview(DirectoryListingView, @model, {
      plugin: @getPlugin()
      currentPage: @getCurrentPage()
      directoryView: @
    })

  pluginEnableView: ->
    @subview(DirectoryPluginEnableView, @model, {
      plugin: @getPlugin()
      currentPage: @getCurrentPage()
      directoryView: @
    })

  searchSubview: ->
    @trackSearch()
    @subview(DirectorySearchView, @model, {
      plugins: @filterOutHiddenPlugins(@getPluginsForSearch()),
      searchTerm: @search,
      currentPage: @getCurrentPage()
      directoryView: @
    })

  pageSubView: (title, plugins) ->
    @subview(DirectoryPageView, @model, {
      title: title
      plugins: @filterOutHiddenPlugins(plugins)
      currentPage: @getCurrentPage()
      directoryView: @
    })

  renderSubview: ->
    # Clear out current subview
    @$contentContainer = @$('#directory-content')
    @$contentContainer.empty()
    if @activeSubview?
      @deleteSubview(@activeSubview)

    # Fancy CoffeeScript switch on nothing.
    # switch statements can also be used without a control expression,
    # turning them in to a cleaner alternative to if/else chains. :shrug:
    @activeSubview = switch
      when @isLoading then @subview(DirectorySpinnerView, @model, {
        @section, @idPlugin, @isEnabling
      })
      when @search then @searchSubview()
      when @section == 'category' && @category then @pageSubView(@category, @getPluginsForCategory())
      when @section == 'custom' then @pageSubView(@section, @getCustomPlugins())
      when @section == 'enabled' then @enabledSubview()
      when @idPlugin && @isEnabling then @pluginEnableView()
      when @idPlugin then @pluginListingSubview()
      else @homeSubview()

    @appendSubview(@activeSubview, @$contentContainer)

  # This sets up the layout of the directory.
  renderOnce: ->
    @appendSubview(@headerView)

    @$el.append('<div class="directory-body js-directory-body"></div>')
    @$directoryBody = @$('.js-directory-body')

    # If the upsell banner is present.
    @setBodyHeight()

    @$directoryBody.append('<div class="directory-responsive-overlay js-directory-responsive-overlay"></div>')

    @appendSubview(@sidebarView, @$directoryBody)

    @$directoryBody.append('<div id="directory-content"></div>')
    @renderSubview()

    return @



// WEBPACK FOOTER //
// ./app/scripts/views/directory/directory-view.coffee